var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgInterfaceEssentialCertificateStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.25 0h24v24h-24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.745 13.465 1.195 1.564.258 1.947A2.411 2.411 0 0 0 7.27 19.05l1.952.261 1.563 1.194a2.411 2.411 0 0 0 2.929 0l1.564-1.195h-.002l1.948-.258a2.411 2.411 0 0 0 2.074-2.072l.26-1.952 1.195-1.563a2.412 2.412 0 0 0 0-2.929L19.56 8.971l-.258-1.947A2.411 2.411 0 0 0 17.23 4.95l-1.953-.26-1.563-1.194a2.411 2.411 0 0 0-2.929 0L9.221 4.69h.002l-1.948.259a2.411 2.411 0 0 0-2.074 2.072L4.94 8.973l-1.195 1.563a2.414 2.414 0 0 0 0 2.929h0z",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.051 15.409.83-.436a.796.796 0 0 1 .738 0l.83.436a.79.79 0 0 0 .835-.061l.31-.225a.795.795 0 0 0 .316-.775l-.159-.924a.793.793 0 0 1 .228-.702l.671-.654a.794.794 0 0 0 .201-.813l-.118-.364a.793.793 0 0 0-.64-.54l-.928-.135a.793.793 0 0 1-.597-.434l-.415-.841a.795.795 0 0 0-.712-.441h-.383a.791.791 0 0 0-.711.442l-.415.841a.793.793 0 0 1-.597.434l-.928.135a.793.793 0 0 0-.64.54l-.118.364a.792.792 0 0 0 .201.813l.671.654a.793.793 0 0 1 .228.702l-.159.924a.792.792 0 0 0 .316.775l.31.225c.244.176.568.2.835.06h0z",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterfaceEssentialCertificateStar);
export default __webpack_public_path__ + "static/media/interfaceEssentialCertificateStar.36b06aad0e83083b3966762068e05e86.svg";
export { ForwardRef as ReactComponent };